import { render, staticRenderFns } from "./NewInstallationDialog.vue?vue&type=template&id=0cfb87fd&"
import script from "./NewInstallationDialog.vue?vue&type=script&lang=js&"
export * from "./NewInstallationDialog.vue?vue&type=script&lang=js&"
import style0 from "./NewInstallationDialog.vue?vue&type=style&index=0&id=0cfb87fd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports